module.exports = __webpack_public_path__ + "media/karten.9bef4e02.mp4";